import React from 'react';

const About = () => (
	<section id='about'>
		<div className='container'>
			<header className='section-header'>
				<h3>About Us</h3>
				<p>
					Aluzinc Roofing solution ltd is an enterprise in sales and services
					industry. . We have all profiling from sheets (Mabati) with colours to
					accessries to ensure that we only sell the best products as per the
					current world-className standards. offering the best products and
					services to the rapidly growing construction industry. . We treat
					people with sincerity, and building We have committed our goals and
					objectives towards the greater good of trust with our customers and
					prospect customers is our company policy. Our products have high
					precision and quality not only excellent in exterior decorative,
					compact ability and anti-corrosion but also have the character of high
					paint adhesion to keep the bright and beautiful color for a long time.
					Aluzinc Panda Mabati Mabati Limited don’t operate in isolation; we
					collaborate to ensure our technologies and service delivery is aligned
					to consistently deliver high-quality products no matter where they are
					delivered.
				</p>
				<blockquote>
					<b>
						<em>
							Talk to us today to get a life long roofing partner to walk with
							you through the journey. If you’re seeking for roofing materials
							for your up coming or current projects, then please call us on
							+254 724758212 and we will help you get the best price roofing
							sheets in the region!
						</em>
					</b>
				</blockquote>
			</header>

			<div className='row about-cols'>
				<div className='col-md-4 wow fadeInUp'>
					<div className='about-col'>
						<div className='img'>
							<img
								src='componentsScripts/img/about-mission.jpg'
								alt=''
								className='img-fluid'
							/>
							<div className='icon'>
								<i className='ion-ios-speedometer-outline'></i>
							</div>
						</div>
						<h2 className='title'>
							<a href='#'>Our Mission</a>
						</h2>
						<p>
							To Provide Quality And Affordable Sheltering Experience Across All
							Households In Kenya.
						</p>
					</div>
				</div>

				<div className='col-md-4 wow fadeInUp' data-wow-delay='0.1s'>
					<div className='about-col'>
						<div className='img'>
							<img
								src='componentsScripts/img/about-plan.jpg'
								alt=''
								className='img-fluid'
							/>
							<div className='icon'>
								<i className='ion-ios-list-outline'></i>
							</div>
						</div>
						<h2 className='title'>
							<a href='#'>Our Plan</a>
						</h2>
						<p>
							We look forward to achieving our goals stepwise in our mission to
							our vision.
						</p>
					</div>
				</div>

				<div className='col-md-4 wow fadeInUp' data-wow-delay='0.2s'>
					<div className='about-col'>
						<div className='img'>
							<img
								src='componentsScripts/img/about-vision.jpg'
								alt=''
								className='img-fluid'
							/>
							<div className='icon'>
								<i className='ion-ios-eye-outline'></i>
							</div>
						</div>
						<h2 className='title'>
							<a href='#'>Our Vision</a>
						</h2>
						<p>
							To Be The Best Roofing materials and accessries Supplier In
							Africa.
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
);
export default About;
